import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import FeastTeamMenuWarehouseEdit from './FeastTeamMenuWarehouseEdit';
import MenuWarehouseIngredient from '../ingredient/MenuWarehouseIngredient';
import { useContext, useEffect, useRef, useState } from 'react'
import { Button, Space } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';
import { SocketContext } from '../../../App';

export default function FeastTeamMenuWarehouse(props: any) {

    const ref = useRef<any>(undefined);
    const apiId = "feastTeamMenuWarehouse";

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    //主配料窗口
    const [menuWarehouseIngredientVisible, setMenuWarehouseIngredientVisible] = useState(false);

    //数据
    const [ingredientData, setIngredientData] = useState<any>();

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //传关参数
    let sendData = {
        type: 'EDIT',
        id: '',
        foodName: '',
        productUnitId: '',
        productUnitName: '',
        path: 'FeastTeamMenuWarehouse',
    }

    const initData = async () => {
        const currentData: initDataType = {
            apiId
        }
        ref.current.initData(currentData);
    }

    //关闭主配料页面
    const onCloseIngredient = async (status: boolean) => {
        setMenuWarehouseIngredientVisible(false);
        if (status) {
            await initData();
        }
    }

    //打开添加主配料
    const handleIngredient = async (record: any) => {
        //console.log(record);

        await fetchApi.POST(wmService, {
            apiId: 'menuWarehouseIngredientDetail',
            apiExtend: 'updatePrice',
            apiData: {
                feastTeamMenuWarehouseId: record.id,
                branchStoreId: contextData?.currentBranchStoreId,
                apiId,
                key: 'FeastTeamMenuWarehouse'
            }
        }).then(res => {
            if (res.success) {
                // console.log(res.data);
            }
        });

        sendData.id = record.id;
        sendData.foodName = record.foodName;
        sendData.productUnitId = record.productUnitId;
        sendData.productUnitName = record.productUnit.productUnitName;
        setIngredientData(sendData);
        setMenuWarehouseIngredientVisible(true);
    };

    //表头
    const columnsHead = [
        {
            title: '所属区域',
            dataIndex: 'areaName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.area.areaName}</div>
                )
            }
        },
        {
            title: '福食菜式类别',
            dataIndex: 'feastTeamMenuWarehouseCategoryName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.feastTeamMenuWarehouseCategory.feastTeamMenuWarehouseCategoryName}</div>
                )
            }
        },
        {
            title: '福食菜式名称',
            dataIndex: 'foodName',
        },
        {
            title: "单位",
            dataIndex: "productUnitName",
            render: (text: any, record: any) => {
                return (
                    <div>{record.productUnit.productUnitName}</div>
                )
            }
        },
        // {
        //     title: "做法",
        //     dataIndex: "cookMethodName",
        // },
        {
            title: '主配料',
            dataIndex: 'ingredient',
            key: 'ingredient',
            render: (text: any, record: any) => {
                if (record.menuWarehouseIngredients.length > 0) {
                    return (
                        <Space size="small">
                            <Button size={"small"} type="primary" onClick={() => handleIngredient(record)}>主配料</Button>
                        </Space>
                    )
                }
                else {
                    return (
                        <Space size="small">
                            <Button size={"small"} danger type="primary" onClick={() => handleIngredient(record)}>主配料</Button>
                        </Space>
                    )
                }
            }
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '福食菜品智库',
        apiId,
        showImage: false,
        showUploadFile: false,
        showStates: false,
        disabledAdd: false,
        showOperation: true,
        showAdd: true,
        pagination: true,
        columns,
        EditComponent: FeastTeamMenuWarehouseEdit,
        mountDataOptions: {
            userMount: {
                isBranchStore: true
            }
        }
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>

            {menuWarehouseIngredientVisible
                ? (<MenuWarehouseIngredient
                    closeModal={onCloseIngredient} data={ingredientData} />)
                : null}
        </>
    )
}